import React, {
  ChangeEvent,
  FunctionComponent,
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
} from 'react';

import { css } from '@emotion/react';
import { Control, FieldErrors, useController } from 'react-hook-form';

interface Props {
  name: string;
  fieldName?: string;
  errors?: FieldErrors<any>;
  control: Control<any>;
  rules: any;
  placeHolder: string;
  handleChange?: (
    e: ChangeEvent<HTMLTextAreaElement>,
    setValue: Dispatch<SetStateAction<string>>,
    fieldOnChange: any
  ) => void;
}

const TextArea: FunctionComponent<Props> = ({
  name,
  control,
  rules,
  placeHolder,
  handleChange,
}) => {
  const { field } = useController({
    control,
    name,
    rules,
  });

  const [value, setValue] = useState(String(field.value));

  useEffect(() => {
    setValue(String(field?.value || ''));
  }, [field.value, setValue]);

  return (
    <div css={container}>
      <textarea
        css={textarea}
        name={name}
        placeholder={placeHolder}
        value={value}
        onBlur={field.onBlur}
        ref={field.ref}
        onChange={(e: any) => {
          if (handleChange) {
            handleChange(e, setValue, field.onChange);
          } else {
            field.onChange(e.target.value);
            setValue(e.target.value);
          }
        }}
        maxLength={4000}
      />
    </div>
  );
};

export default TextArea;

const container = css`
  width: 100%;
  padding: 10px 20px 10px 0;
`;

const textarea = css`
  width: 100%;
  height: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
  box-sizing: border-box;

  &:focus {
    outline: none;
  }
`;
